// Utilities to detect image / GIF URLs and render them inline

const IMG_EXT_RE = /\.(gif|png|jpe?g|webp|avif|apng)(\?.*)?$/i;
const GIPHY_MEDIA_RE = /^https?:\/\/media\d?\.giphy\.com\/media\/[^\s]+/i;
const GIPHY_PAGE_RE = /^https?:\/\/(?:www\.)?giphy\.com\/gifs\/(?:[^\/\s]+-)?([a-zA-Z0-9]+)/i;
const TENOR_RE = /^https?:\/\/(?:media\d?\.)?tenor\.com\/[^\s]+/i;
const DATA_IMG_RE = /^data:image\//i;

export function isImageUrl(url) {
  if (!url) return false;
  return (
    IMG_EXT_RE.test(url) ||
    GIPHY_MEDIA_RE.test(url) ||
    GIPHY_PAGE_RE.test(url) ||
    TENOR_RE.test(url) ||
    DATA_IMG_RE.test(url)
  );
}

// Normalise a giphy page URL (giphy.com/gifs/foo-bar-abc123) to the direct .gif
export function normalizeImageUrl(url) {
  if (!url) return url;
  const m = url.match(GIPHY_PAGE_RE);
  if (m && m[1]) return `https://media.giphy.com/media/${m[1]}/giphy.gif`;
  return url;
}

// Split a body into text tokens + image tokens
export function tokenizeBody(body) {
  if (!body) return [];
  const parts = body.split(/(\s+)/);
  return parts.map((p) => (isImageUrl(p.trim()) ? { type: "image", url: normalizeImageUrl(p.trim()) } : { type: "text", value: p }));
}
